import "./PromotionLabels.scss";

import { default as moment } from "moment";
import * as _ from "lodash";

import * as React from "react";
import PropTypes from "prop-types";
import { SessionStore } from "shared/src/uidispatcherapi/SessionStore";

import { Label, OverlayTrigger } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import { FlashSaleCounter } from "./FlashSaleCounter";

import { SellingPriceDnrInfo, PriceAndPromotionInfo } from "shared/src/types/PriceAndPromotionInfo";
import { ArticleCardGiftPopup } from "./article-badges/bundles/articlecard/ArticleCardGiftPopup";
import CountryUtil from "shared/src/uidispatcherapi/CountryUtil";
import { trackFreeProductHover } from "../../../utils/ArticleTrackingUtil";
import { TrackingTags } from "shared/src/tracking/Tracking";
import { SellingPriceDnRInfo } from "shared/src/types/EvaluateArticleNew";

// TODO(FD) maybe this should be configurable somewhere?
const infoStylePromotions = ["web-exclusive"];
const warningStylePromotions = ["GOOD_DEAL"];
const MAX_NUMBER_OF_LABELS = 2;

export type PromotionLabelsProps = {
    priceAndPromotionInfo: PriceAndPromotionInfo;
    rewardIds: string[] | null;
    onList: boolean;
    recentlyOrdered: boolean;
    recentlyOrderedDateString?: string;
    bundleId: string;
    eventId: string;
    trackingId: string;
    trackingInfo: TrackingTags;
};

export class PromotionLabels extends React.Component<PromotionLabelsProps> {
    static contextTypes = {
        intl: PropTypes.object.isRequired
    };
    mouseEntryTimestamp: number | null;

    constructor(props: PromotionLabelsProps) {
        super(props);
        this.mouseEntryTimestamp = null;
    }

    getDuration(start: string | undefined | null, end: string | undefined | null) {
        if (!start || !end) return null;
        const dateFormat = this.context.intl.formatMessage({
            id: "EX_PROMOTION_LABEL_DATE_FORMAT"
        });
        return {
            start: moment(start).format(dateFormat),
            end: moment(end).format(dateFormat)
        };
    }

    renderGiftsLabel() {
        const numRewards = this.props.rewardIds ? this.props.rewardIds.length : 0;
        const giftId = this.props.rewardIds && numRewards === 1 ? this.props.rewardIds[0] : null;
        const shouldShowMultipleGifts = numRewards > 1;
        if (giftId) {
            return (
                <OverlayTrigger
                    trigger="hover"
                    placement="top"
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    shouldUpdatePosition
                    overlay={<ArticleCardGiftPopup bundleId={giftId} />}>
                    <Label
                        onMouseEnter={() => this.trackEnter()}
                        onMouseLeave={() => this.trackLeave(numRewards, true)}
                        className="label-rectangular label-gift sd-label-gift-article-card">
                        <FormattedMessage id="EX_FREE_GIFT_LABEL" />
                    </Label>
                </OverlayTrigger>
            );
        } else if (shouldShowMultipleGifts) {
            return (
                <Label
                    onMouseEnter={() => this.trackEnter()}
                    onMouseLeave={() => this.trackLeave(numRewards, false)}
                    className="label-rectangular label-gift sd-label-gift-article-card">
                    <FormattedMessage id="EX_FREE_GIFTS_LABEL" />
                </Label>
            );
        } else return null;
    }

    trackEnter() {
        this.mouseEntryTimestamp = Date.now();
    }

    trackLeave(numRewards: number, popoverShown: boolean) {
        if (this.mouseEntryTimestamp !== null && Date.now() - this.mouseEntryTimestamp > 500) {
            trackFreeProductHover(
                this.props.eventId,
                this.props.bundleId,
                this.props.trackingId,
                this.props.recentlyOrdered,
                this.props.onList,
                this.props.trackingInfo,
                numRewards,
                popoverShown
            );
        }
    }

    getFlashSaleLabel(
        dnrInfo: SellingPriceDnrInfo | SellingPriceDnRInfo | undefined | null,
        flashSaleCounter: number | undefined | null
    ) {
        const flashCounter = flashSaleCounter ? flashSaleCounter : dnrInfo && dnrInfo.flashSalesCounter;
        const duration = dnrInfo && this.getDuration(dnrInfo.start, dnrInfo.end);
        return (
            <div>
                {flashCounter && (
                    <FlashSaleCounter
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore -- it's used in a shallow test, even though the actual component doesn't use it
                        className="test-flashsale"
                        value={flashCounter}
                    />
                )}
                {duration && (
                    <Label
                        key="flash"
                        className="label-promotion label-rectangular test-label-promotion label-rectangular">
                        <FormattedMessage id={"EX_PROMOTION_FLASH_WITH_DURATION"} values={duration} />
                    </Label>
                )}
            </div>
        );
    }

    renderFlashSaleLabels(
        priceInfo: PriceAndPromotionInfo,
        flashSaleCounter: number | undefined | null
    ): {
        [x: string]: any;
    } {
        const dnrsInfo = priceInfo.dnrInfo || {};
        const flashSales = _.chain(dnrsInfo)
            .filter((dnrInfo) => dnrInfo.flashSale === true)
            .map((dnrInfo) => this.getFlashSaleLabel(dnrInfo, flashSaleCounter))
            .value();
        if (_.isEmpty(flashSales) && flashSaleCounter) {
            return this.getFlashSaleLabel(null, flashSaleCounter);
        }
        return flashSales;
    }

    render() {
        const priceInfo = this.props.priceAndPromotionInfo;
        const promotionLabels = priceInfo.promotionLabels || [];
        const promotionLabelsArray = Object.values(promotionLabels);
        if (this.props.rewardIds && this.props.rewardIds.length > 0) {
            promotionLabelsArray.push({ type: "free-gift", start: null, end: null, displayPriority: 6.0 });
        }
        const sortedPromotionLabels = promotionLabelsArray.sort((prom1, prom2) => {
            if (prom1.displayPriority && prom2.displayPriority) {
                return prom1.displayPriority > prom2.displayPriority ? -1 : 1;
            }
            return prom1.displayPriority ? -1 : 1;
        });
        const flashSaleCounter = priceInfo.flashSalesCounter;
        if (
            _.size(sortedPromotionLabels) === 0 &&
            !this.props.onList &&
            !this.props.recentlyOrdered &&
            (flashSaleCounter === null || flashSaleCounter === undefined)
        ) {
            return this.props.rewardIds ? (
                <div className="mfcss_card-article-2--discounts">{this.renderGiftsLabel()}</div>
            ) : null;
        }
        let labels: Array<React.ReactNode> = [];
        if (this.props.onList) {
            labels.push(
                <Label className="label-rectangular label-personal">
                    <FormattedMessage id="EX_LABEL_ON_YOUR_LIST" />
                </Label>
            );
        } else if (this.props.recentlyOrdered) {
            labels.push(
                <Label className="label-rectangular label-personal">
                    {this.props.recentlyOrderedDateString ? (
                        <FormattedMessage
                            id="EX_LABEL_RECENTLY_ORDERED_WITH_DATE"
                            values={{
                                date: this.props.recentlyOrderedDateString
                            }}
                        />
                    ) : (
                        <FormattedMessage id="EX_LABEL_RECENTLY_ORDERED" />
                    )}
                </Label>
            );
        }
        labels = labels.concat(
            _.map(sortedPromotionLabels, (promo) => {
                if (promo.type === "flash") {
                    return this.renderFlashSaleLabels(priceInfo, flashSaleCounter);
                }
                if (promo.type === "free-gift") {
                    return this.renderGiftsLabel();
                }
                const translationKey = "EX_PROMOTION_" + promo.type.toUpperCase();

                //implementation of displaying timerange in promotion labels is adapted from EV
                let validityRangeText = null;
                const startDate = promo.start;
                const endDate = promo.end;
                if (startDate && endDate) {
                    let start = moment.utc(startDate);
                    let end = moment.utc(endDate);
                    /**
                     * The price team has fixed the timezone of promotions start and end date only for FR right now.
                     * In all other countries the timezone MUST be ignored.
                     * The fix on price side planned in BTP-9152.
                     * Since some countries are already running on their new engine "Enzo",
                     * they have to be excluded from the workaround as well.
                     */
                    if (
                        SessionStore.getCountry() === "FR" ||
                        (typeof CountryUtil.isEnzoCountry === "function" && CountryUtil.isEnzoCountry())
                    ) {
                        start = start.local();
                        end = end.local();
                    }
                    /**
                     * Even worse, the price services use 0:00:00 on the following day as time for marketplace.and
                     * 23:59:59 as time on the same day for everything else.
                     */
                    let startDateFormat = this.context.intl.formatMessage({
                        id: "EX_PROMOTION_LABEL_DATE_FORMAT"
                    });
                    let endDateFormat = this.context.intl.formatMessage({
                        id: "EX_PROMOTION_LABEL_DATE_FORMAT"
                    });
                    if (end.hour() === 0 && end.minute() === 0) {
                        end.subtract(1, "minute");
                    }
                    if (start.hour() > 0) {
                        startDateFormat = this.context.intl.formatMessage({
                            id: "EX_PROMOTION_LABEL_DATE_AND_TIME_FORMAT"
                        });
                    }
                    if (end.hour() < 23) {
                        endDateFormat = this.context.intl.formatMessage({
                            id: "EX_PROMOTION_LABEL_DATE_AND_TIME_FORMAT"
                        });
                    }
                    validityRangeText = (
                        <FormattedMessage
                            className="test-promotion-date-range"
                            id={"EX_ARTICLE_PROMOTION_VALIDITY"}
                            values={{
                                from: start.format(startDateFormat),
                                to: end.format(endDateFormat)
                            }}
                        />
                    );
                }

                //if that translation exist: display that Label
                if (this.context.intl.messages[translationKey]) {
                    let style: string;
                    if (_.includes(infoStylePromotions, promo.type)) {
                        style = "label-info";
                    } else if (_.includes(warningStylePromotions, promo.type)) {
                        style = "label-warning";
                    } else {
                        style = "label-promotion";
                    }
                    return (
                        <Label
                            key={translationKey}
                            className={
                                "label-rectangular " + style + (promo.type === "web-exclusive" ? " web-exclusive" : "")
                            }>
                            <FormattedMessage id={translationKey} /> {validityRangeText}
                        </Label>
                    );
                } else {
                    return null;
                }
            })
        );
        return <div className="mfcss_card-article-2--discounts">{labels.slice(0, MAX_NUMBER_OF_LABELS)}</div>;
    }
}
